import { connect } from 'react-redux';
import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import RedoRoundedIcon from '@mui/icons-material/RedoRounded';

const styles = theme => ({ });

class RedoActionButton extends React.Component {

    render() {
        const { futureHistoryItemsLength, redo, savingInProgress, showCriticalOperationProgressWarning } = this.props;

        const onClick = () => {
            if (savingInProgress) {
                showCriticalOperationProgressWarning();
                return;
            }
            redo();
        };

        return (
            <Tooltip 
                title='Redo' 
                arrow 
                placement='bottom'
            >
                <div>
                    <IconButton
                        onClick={onClick}
                        disabled={!futureHistoryItemsLength}
                        aria-label='Redo'
                        size="large">
                        <RedoRoundedIcon />
                    </IconButton>
                </div>
            </Tooltip>
        );
    }
}

const mapStateToProps = (state) => {
    const { length: futureHistoryItemsLength } = state.createPreview.future;
    const { savingInProgress } = state.create.videoSavingState;
    return { futureHistoryItemsLength, savingInProgress }
}

const mapDispatchToProps = (dispatch) => {
    const redo = () => dispatch(createActions.redo());
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());

    return {
        redo,
        showCriticalOperationProgressWarning
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(RedoActionButton, styles));